










import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Viewws
import ContactUsModal from '@/views/all/modals/ContactUsModal.vue'
import DownloadAppModal from '@/views/all/modals/DownloadAppModal.vue'

@Component({
  components: {
    ContactUsModal,
    DownloadAppModal
  }
})
export default class TopBarCtaButtons extends Vue {
  @Getter('token') token
  @Getter('premium', { namespace: 'user' }) isPremium
  @Getter('canTrial', { namespace: 'user' }) canTrial
  @Getter('isTrial', { namespace: 'user' }) isTrial
  @Getter('trialRemaining', { namespace: 'user' }) daysLeft

  openContactModal() {
    this.$modal.open({
      parent: this,
      component: ContactUsModal
    })
  }

  // Become Pro is user is in trial mode or if trial mode has expired and not pro yet
  get canSubscribe(): boolean {
    return !this.isTrial && !this.canTrial && !this.isPremium
  }

  submitTrial() {
    window.location.href = `${this.$trialUrl}/#/login/${this.token}`
  }
}
